import React, { Fragment } from 'react';

const commonPoints = [
  {
    key: 'requirement',
    description: 'Payments are automatically deducted from your linked bank account (Auto Pay)',
  },
  {
    key: 'renewal',
    description: 'Your subscription renews automatically and you are free to cancel at anytime.',
  },
];

/* eslint-disable max-len */
export const PlusPoints = [
  {
    key: 'regularDiscount',
    description: <Fragment><b>Save 20¢/gal guaranteed</b> and <b>22¢/gal</b> at select stations (up to 50 gallons per month), then 5¢/gal thereafter.</Fragment>,
  },
  {
    key: 'extraDiscount',
    description: <Fragment>Spend $25 in-store, <b>earn an extra 3¢/gal</b></Fragment>,
  },
  {
    key: 'maxDiscount',
    description: <Fragment><b>Save up to 50¢/gal</b> with activated Flash Deals</Fragment>,
  },
  {
    key: 'dailyLimit',
    description: <Fragment><b>$120 daily</b> spending limit</Fragment>,
  },
  {
    key: 'pumpLimit',
    description: <Fragment><b>$100 pump</b> transaction limit</Fragment>,
  },
  {
    key: 'weeklyLimit',
    description: <Fragment><b>$400 weekly</b> spending limit</Fragment>,
  },
  ...commonPoints,
];

export const PremiumPoints = [
  {
    key: 'regularDiscount',
    description: <Fragment><b>Save 20¢/gal guaranteed</b> and <b>22¢/gal</b> at select stations (up to 50 gallons per month), then 5¢/gal thereafter.</Fragment>,
  },
  {
    key: 'extraDiscount',
    description: <Fragment>Spend $25 in-store, <b>earn an extra 3¢/gal</b></Fragment>,
  },
  {
    key: 'maxDiscount',
    description: <Fragment><b>Save up to 50¢/gal</b> with activated Flash Deals</Fragment>,
  },
  {
    key: 'roadside',
    description: <Fragment><b>24-hour roadside assistance,</b> provided by Allstate</Fragment>,
  },
  {
    key: 'dailyLimit',
    description: <Fragment><b>$120 daily</b> spending limit</Fragment>,
  },
  {
    key: 'pumpLimit',
    description: <Fragment><b>$100 pump</b> transaction limit</Fragment>,
  },
  {
    key: 'weeklyLimit',
    description: <Fragment><b>$400 weekly</b> spending limit</Fragment>,
  },
  ...commonPoints,
];
/* eslint-enable max-len */

export const PassengerVehicleDefinition = 'A passenger vehicle is a vehicle designed to carry no more than nine passengers, including the driver, and does not include motorcycles or RVs. A light duty vehicle is under 10,000 lbs.';
export const PassengerVehicleDetail = 'If you do not drive a light duty passenger vehicle, you can not purchase a premium membership.';
